module.exports = __webpack_public_path__ + "static/img/1.0db2093.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.jpg
// module id = 87
// module chunks = 2